<template>
  <v-container>
    <h2>
    分析サンプルを採取登録する
    </h2>
    <br>
    <div class="mb-3 body-2">
      採油したサンプル情報はこの画面から登録してください。
      サンプル情報の登録時に、オイル分析・診断の依頼指定や、フィルター返却、サンプル返却等のオプション指定、分析料金の確認などができます。
    </div>

    <div class="my-4">
      <h3>分析サンプルの採取登録画面でできること</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4">
      <v-row>
        <v-col cols="12" dense class="pa-0">
          <v-icon color=primary>mdi-numeric-1-box</v-icon>
          <span class="ml-2 primary--text title font-weight-bold">分析・診断項目の指定</span>
        </v-col>
        <v-col cols="12" dense class="pa-2 pl-6 body-2">
            分析方法や分析区分、分析項目を指定することができます。<br>
            また、分析規格を報告書への掲載要否も指定することができます。
            特記事項やジャパン・アナリストへの伝達事項がある場合は、サンプルメモとして自由にテキストを入力することができます。
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" dense class="pa-0">
          <v-icon color=primary>mdi-numeric-2-box</v-icon>
          <span class="ml-2 primary--text title font-weight-bold">返却要否の指定</span>
        </v-col>
        <v-col cols="12" dense class="pa-2 pl-6 body-2">
            ジャパン・アナリストへ送付いただくフィルターやサンプルの返却の要否を指定することができます<br>
            併せてフィルター返却時のラミネート加工の要否も指定することができます。
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" dense class="pa-0">
          <v-icon color=primary>mdi-numeric-3-box</v-icon>
          <span class="ml-2 primary--text title font-weight-bold">分析料金や必要サンプル量、機器情報の確認</span>
        </v-col>
        <v-col cols="12" dense class="pa-2 pl-6 body-2">
            サンプル採取対象となる機器の情報を確認することができます。<br>
            指定いただいた分析項目情報や返却要否情報から分析料金を算出します。<br>
            分析に必要なオイルのサンプル量も確認することができます。
        </v-col>
      </v-row>
    </div>

    <div class="my-4">
      <h3>分析・診断項目の説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      分析・診断項目として指定可能な項目は次の通りです。「必須」列に<v-icon color=success>mdi-check</v-icon>チェックが入っている項目は入力必須箇所です。
    </div>

    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="analizeData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">必須</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in analizeData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td v-if="item.isRequire==true"><v-icon small color=success>mdi-check</v-icon></td>
              <td v-else></td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="mb-4 mt-8">
      <h3>返却要否項目の説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      返却要否を指定していただく必要のある項目は次の通りです。
    </div>

    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="optionData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in optionData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="mb-4 mt-8">
      <h3>サンプル採取情報の説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      必要なサンプル量や分析料金、サンプル採取日など、サンプル採取時に確認していただく項目です。
    </div>

    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="sampleData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">必須</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sampleData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td v-if="item.isRequire==true"><v-icon small color=success>mdi-check</v-icon></td>
              <td v-else></td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="my-8 mb-4">
      <h3>分析サンプルの採取登録画面への行き方</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      分析サンプルの採取登録画面へは複数の方法で行くことができます。
    </div>

    <div class="mt-4 body-1">
      (1) マイ機器QRコードから
    </div>
    <div class="ml-4 my-4 body-2">
      マイ機器ごとに発行される「マイ機器QRコード」をスマートフォンやタブレット等からスキャンすると、直接分析サンプルの採取登録画面へアクセスすることができます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-03.png" width="30%" class="my-2">
    </div>

    <div class="ml-4 body-2" align="center">
      <v-card outlined class="pa-4" color="amber lighten-4" max-width="600px">
        <div class="body-2 mb-3">
          <v-icon>mdi-information-outline</v-icon>
          マイ機器QRコードの印刷のしかたはこちらのマニュアルをご確認ください。
          </div>
        <div align="center">
          <v-btn small class="white--text" color="success" @click="showMan('manMyMachineQrPrint')">
            「マイ機器QRコードを印刷する」マニュアルを見る
          </v-btn>
        </div>
      </v-card>
    </div>

    <div class="mt-4 body-1">
      (2) お申込みページから
    </div>
    <div class="ml-4 my-4 body-2">
      メニューの「お申込み」をクリックします。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-01.png" width="70%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「サンプル採取の登録」のマイ機器リストの中にある対象機器の右側のボタンをクリックすると分析サンプルの採取登録画面へ行くことができます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-02.png" width="90%" class="my-2">
    </div>

    <div class="mt-4 body-1">
      (3) マイ機器から
    </div>
    <div class="ml-4 my-4 body-2">
      メニューの「マイ機器」をクリックします。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-04.png" width="70%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      マイ機器リストより、サンプル採取対象の機器をクリックします。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-05.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      マイ機器情報更新画面の上部にある「分析サンプルを登録」ボタンをクリックすると分析サンプルの採取登録画面へ行くことができます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-06.png" width="90%" class="my-2">
    </div>

    <div class="my-8 mb-4">
      <h3>サンプルの登録</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      分析サンプルを登録する流れを以下に説明します。
    </div>

    <div class="ml-4 my-4 body-2">
      画面上部の「選択中のマイ機器情報」を確認し、採油対象の機器であることを確認します。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-08.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      次に、項番１の「オイル分析・診断内容」の項目を入力します。<br>
      分析方法、分析区分の選択に応じて、指定可能な分析項目が「セット分析」「個別分析項目」に表示されますので選択します。<br>
      「セット分析」のみ、「個別分析」のみ、「セット分析」＋「個別分析」の組み合わせが可能です。<br>
      分析・診断報告書に分析規格の記載を希望する場合は、「報告書へ分析規格を記載する」のスイッチをＯＮにし、規格を選択してください。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-09.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「報告書へ分析規格を記載する」スイッチを有効化した場合は、次のような画面が表示されますので、分析規格を選択してください。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-10.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      次に、フィルター返却の要否、サンプル返却の要否を選択してください。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-11.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      分析に必要なサンプル量、分析料金は、分析項目や返却の要否の選択結果から自動計算されますので確認してください。<br>
      そして、サンプルを採取した日を「サンプル採取日」として選択してください。
      サンプルボトル数も併せて入力します。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-12.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      最後にサンプルメモを入力してください。サンプルメモは特記事項やジャパン・アナリストへの伝達事項がある場合に入力します。入力しなくても構いません。<br>
      以上の項目を入力し終えたら、「分析サンプルを登録」ボタンをクリックしてください。確認画面が開きます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-14.png" width="90%" class="my-2">
    </div>
    <div class="ml-4 my-4 body-2">
      確認画面で入力内容の最終確認をします。<br>
      問題が無ければ画面右下の「分析サンプルを登録する」ボタンをクリックしてください。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-15.png" width="90%" class="my-2">
    </div>



  </v-container>
</template>
<script>
export default {
    data: () => ({
        buttonName: '',
        analizeData: [
          {
            name: '分析方法',
            body: '社定法か、公定法のいずれかを選択してください。',
            isRequire: true
          },
          {
            name: '分析区分',
            body: '選択メニューからいずれかを選択してください。',
            isRequire: true
          },
          {
            name: 'セット分析',
            body: '分析区分にセット分析メニューがある場合は表示されます。セット分析としてご依頼される場合はいずれかを選択してください。「セットに含まれる分析項目」に選択したセットに含まれる分析項目が表示されます。',
            isRequire: false
          },
          {
            name: '個別分析項目',
            body: '個々に分析項目を指定してご依頼される場合は、選択メニューからいずれかを選択してください。',
            isRequire: false
          },
          {
            name: '報告書に分析規格を記載する',
            body: '分析結果の報告書に分析規格を記載する場合は選択してください。有効にすると分析規格の選択が開きます',
            isRequire: false
          },
          {
            name: '分析規格',
            body: '報告書に分析規格を記載する場合は選択してください。',
            isRequire: false
          },
        ],
        optionData: [
          {
            name: 'フィルター返却',
            body: '分析後にフィルター返却を望まれる場合は、必要のいずれかを選択してください。ラミネート加工の有無で費用が変動します。',
            isRequire: false
          },
          {
            name: 'サンプルの返却',
            body: '分析後にサンプルの返却を望まれる場合は、「返却を希望」を選択してください。着払いで返送いたします。',
            isRequire: false
          },
        ],
        sampleData: [
          {
            name: '分析に必要なサンプル量',
            body: '指定いただいた分析項目で必要なサンプル量です。指定されたサンプル量をサンプルボトルに入れてください。',
            isRequire: false
          },
          {
            name: '分析料金',
            body: '指定いただいた分析項目の料金の総計です。価格は標準価格です。',
            isRequire: false
          },
          {
            name: 'サンプル採取日',
            body: 'サンプルを採取した日を指定してください。',
            isRequire: true
          },
          {
            name: 'サンプルボトル数',
            body: 'ジャパン・アナリストへ送付するボトル数を指定してください。',
            isRequire: true
          },
          {
            name: 'サンプルメモ',
            body: '特記事項やジャパン・アナリストへ伝達したい事項がありましたら記入してください。最大64文字です。',
            isRequire: false
          },


        ]

    }),
    methods: {
      showMan: async function(value) {
      var url = '/UserManual/' + value
      this.$router.push(url)        
      }
    }
}
</script>

